export class ECONNABORTEDError extends Error {}
export class ERR_NETWORKError extends Error {}
export class ETIMEDOUTError extends Error {}
export class ResponseError extends Error {}
export class Unauthorized401Error extends ResponseError {}
